import { ViewerKindSchema } from "./fileViewerInterface";
import { INTERACTION_QUERY_KEYS } from "../../FpPages/RMS/Data/interactions";
import { useQuery } from "@tanstack/react-query";
import {
  fetchInteraction,
  fetchInteractionByBlobId,
} from "../../FpPages/RMS/Dashboard/api";

/** Explicit interaction context is authoritative; a failed read never falls back to a sibling. */
export const useViewerInteraction = (
  blobId: string | null | undefined,
  interactionId?: string | null,
  enabled = true
) => {
  const query = useQuery({
    queryKey: interactionId
      ? INTERACTION_QUERY_KEYS.detail(interactionId)
      : ["interactionByBlob", blobId],
    queryFn: ({ signal }) => {
      if (interactionId) return fetchInteraction(interactionId, signal);
      if (blobId) return fetchInteractionByBlobId(blobId, signal);
      return null;
    },
    enabled: enabled && Boolean(interactionId || blobId),
    staleTime: 5000,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  return { ...query, data: query.isError ? undefined : query.data };
};

const useInteractionByBlobId = (
  blobId: string | null,
  enabled: boolean,
  interactionId?: string | null
) => {
  const { data } = useViewerInteraction(blobId, interactionId, enabled);
  if (!enabled || !data) return null;
  // Attachment-only associations are not the document's own interaction.
  return interactionId || data.document_id === blobId ? data : null;
};
export default useInteractionByBlobId;

export const interactionViewerKind = (kind: string | null | undefined) => {
  const parsed = ViewerKindSchema.safeParse(kind);
  return parsed.success ? parsed.data : undefined;
};
